module.exports = __webpack_public_path__ + "img/inverter_gray.34c3c119.png";